module.exports = __webpack_public_path__ + "./fonts/montserrat-latin-700italic.ca627c5ccc65cf80c2ecaea44b997de9.woff";